module.exports = __webpack_public_path__ + "bd2a51c81a6186f6f807fe4bd33c7f5c.png";